// ServidorPage.tsx
import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { useFetchGetServidores, useFetchDeleteServidor, useFetchPatchEstadoServidor } from "@/shared/actions";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useTableFilter,
  // useTableServerSideFiltering,
} from "@/shared";
import { MRT_ColumnFiltersState } from 'material-react-table';
import { useUiConfirmModalStore } from "@/store/ui";
import { Servidor } from "../../types";
import {
  SwitchComponente,
} from "@/shared/components/ui";
import { useAuthStore } from "@/store/auth/auth.store"; 
import { useUserModulesStore } from "@/store/auth";       
import { SystemModulesEnum } from "@/auth/interfaces";
import { Outlet } from "react-router-dom";
import { toFilterParams } from "../../utils";

export default function ServidorPage() {
    const user = useAuthStore((s) => s.user) as any; 
        const userModules = useUserModulesStore((s) => s.modules);  
        const isSuper = !!user?.is_superuser || !!user?.is_staff; 
        const tineAccesoAreacontrolAreas = userModules.includes(SystemModulesEnum.CONTROL_CAMBIOS_SERVIDORES) 

  const returnUrl = ROUTER_PATHS.control_cambios.servidorNav;
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore((s) => s.setConfirmDialogIsOpen);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const { pagination, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;
  // const { columnFilters, setColumnFilters } = useTableServerSideFiltering();

  const { data: response, isLoading, isRefetching } = useFetchGetServidores({
    page: pageIndex,
    size: pageSize,
    ...toFilterParams(columnFilters),
  });

  const patchEstado = useFetchPatchEstadoServidor();

  const deleteServidor = useFetchDeleteServidor();

  const onEdit = (original: Servidor) => {
    setConfirmDialog({
      isOpen: true,
      title: "Editar servidor",
      subtitle: "¿Está seguro que desea editar este registro?",
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        navigate(`${returnUrl}/editar/${original.servidorId}`);
      },
    });
  };

  const onDelete = (origin: Servidor) => {
    setConfirmDialog({
      isOpen: true,
      title: "Eliminar servidor",
      subtitle: `¿Está seguro que desea eliminar el servidor "${origin.nombreServidor}"? Esta acción no se puede deshacer.`,
      onConfirm: () => {
        setConfirmDialogIsOpen(false);
        deleteServidor.mutate(origin.servidorId!);
      },
    });
  };

  const columns = useMemo<MRT_ColumnDef<Servidor>[]>(
    () => [
      { accessorKey: "codigo",
              header: "Codigo de identificacion",
              size: 180,
              Cell: ({ row }) => (
                
                  row.original?.codigo || "N/A"
           
              ),},
     { accessorKey: "nombreServidor", header: "Nombre", size: 160, Cell: ({ row }) => row.original?.nombreServidor || "N/A" },
      { accessorKey: "ipServidor", header: "IP", size: 140, Cell: ({ row }) => row.original?.ipServidor || "N/A" },
      { 
        accessorKey: "tipoServidor",
        header: "Tipo",
        size: 110,
        filterVariant: "select",
        filterSelectOptions: [
        { text: "FISICO", value: "FISICO" },
        { text: "VIRTUAL", value: "VIRTUAL" },
      ],
        Cell: ({ row }) => row.original?.tipoServidor || "N/A"
       },
      { 
        accessorKey: "ambiente", 
        header: "Ambiente", 
        size: 120, 
        filterVariant: "select",
        filterSelectOptions: [
          { text: "PRODUCCION", value: "PRODUCCION" },
          { text: "DESARROLLO", value: "DESARROLLO" },
        ],
        Cell: ({ row }) => row.original?.ambiente || "N/A" },
      { accessorKey: "categoria", header: "Categoría", size: 120, 
        filterVariant: "select",
        filterSelectOptions: [
          { text: "SERVIDOR", value: "SERVIDOR" },
          { text: "SOFTNET", value: "SOFTNET" },
          { text: "NOC", value: "NOC" },
          { text: "EVA", value: "EVA" },
          { text: "FIBRAMAX", value: "FIBRAMAX" },
        ],
        Cell: ({ row }) => row.original?.categoria || "N/A" },
      { accessorKey: "sistemaOperativo", header: "S.O.", size: 120, 
        filterVariant: "select",
        filterSelectOptions: [
          { text: "WINDOWS", value: "WINDOWS" },
          { text: "MACOS", value: "MACOS" },
          { text: "LINUX", value: "LINUX" },

        ],
        Cell: ({ row }) => row.original?.sistemaOperativo || "N/A" },
      {
      accessorKey: "estado",
      header: "¿Activo?",
      filterVariant: "select",
      filterSelectOptions: [
        { text: "Activo", value: "true" },
        { text: "Inactivo", value: "false" },
      ],
      Cell: ({ row }) => (
        <SwitchComponente
          estadoSwitch={!!row.original.estado}
          titulo={row.original.estado ? "Activo" : "Inactivo"}
          setEstadoSwitch={() => {
            setConfirmDialog({
              isOpen: true,
              title: "Cambiar estado",
              subtitle: "¿Seguro que desea cambiar el estado del servidor?",
              onConfirm: () => {
                setConfirmDialogIsOpen(false);
                patchEstado.mutate({ id: row.original.servidorId!, estado: !row.original.estado });
              },
            });
          }}
        />
      ),
    },
      { 
        accessorKey: "estadoCritico",
        header: "¿Crítico?",
        filterVariant: "select",
        filterSelectOptions: [
          { text: "Crítico", value: "true" },
          { text: "No crítico", value: "false" },
        ],
        size: 110,
        Cell: ({ row }) => (row.original?.estadoCritico ? "Sí" : "No") 
      },
    ],
    []
  );
    if(!isSuper || !tineAccesoAreacontrolAreas){
  return (
    <SingleTableBoxScene
      title={"Servidores de control de cambios"}
      urlRedirect={`${returnUrl}/crear`}
      py={2}
    >
      <GeneralTable<Servidor>
        columns={columns}
        data={response?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        enableGlobalFilter={false}
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        pagination={pagination}
        onPaging={setPagination}
        rowCount={response?.totalElements ?? 0}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        canEdit={true}
        onEdit={onEdit}
        canDelete={true}
        onDelete={onDelete}
      />
    </SingleTableBoxScene>
  );
   }
        return <Outlet />;
}